// @flow
import { compose } from 'redux';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import type { State } from 'types/redux';
import type { Props } from './UnavailableBanner';

// Components
import UnavailableBanner from './UnavailableBanner';

// Selectors
import {
  transportWithoutValet,
  isTransportationAvailable
} from 'store/reducers/apptOptions/selectors';
import { getTranspOptionInfo } from 'store/reducers/appointment/selectors';

const mapStateToProps = (state: State): $Shape<Props> => ({
  transpOptionInfo: getTranspOptionInfo(state),
  transportOptions: transportWithoutValet(state),
  isTransportationAvailable: isTransportationAvailable(state)
});

export default compose(
  injectIntl,
  connect(
    mapStateToProps,
    null
  )
)(UnavailableBanner);



// WEBPACK FOOTER //
// ./src/components/atoms/UnavailableBanner/UnavailableBannerContainer.js